import React from 'react';
import { displayLabel, schemaLabel } from '../labels';

// Editable display labels for a set of column keys. Binning a numeric field
// and aggregating its distribution produces verbose keys such as
// "distribution__area_bin__Small"; this lets a user rename them for legends,
// tooltips, donut segments and table headers without changing the data. Each
// input is pre-filled with the label currently shown (the override if any,
// else the schema label, else the raw key) so editing is always in place.
export default function SeriesLabelsControl({
  label = 'Display labels',
  keys = [],
  fields = [],
  value = {},
  onChange
}) {
  if (keys.length === 0) return null;

  const update = (key, text) => onChange({ ...value, [key]: text });

  return (
    <div className="form-field">
      <span className="form-label">{label}</span>
      {keys.map((key) => (
        <div className="series-label-row" key={key}>
          <span className="series-label-key" title={key}>
            {shortKey(key)}
          </span>
          <input
            className="series-label-input form-input"
            type="text"
            value={displayLabel(value, key, schemaLabel(fields, key) || key)}
            onChange={(e) => update(key, e.target.value)}
          />
        </div>
      ))}
    </div>
  );
}

// Trailing readable part of an auto-generated key: "…__Small" → "Small".
function shortKey(key) {
  const parts = String(key).split('__');
  return parts[parts.length - 1] || key;
}
